import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section id="agendar" className="bg-brand-charcoal py-12 md:py-16 px-4 relative overflow-hidden" data-id="element-39">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-brand-orange/20 rounded-full blur-[150px] pointer-events-none" data-id="element-40"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-42">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 text-balance leading-tight" data-id="element-43">
            ¿Listo Para Recibir Los Mejores Leads del Mercado Hispano?
          </h2>

          <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-44">
            Agenda tu llamada gratuita hoy y descubre cómo podemos ayudarte a
            cerrar más ventas.
          </p>

          <a href="https://calendly.com/josephgh19/x-leads-consultation" target="_blank" rel="noopener noreferrer" className="inline-block bg-brand-orange hover:bg-orange-500 text-white px-8 md:px-12 py-5 rounded-xl font-bold text-base md:text-xl transition-all shadow-[0_0_40px_rgba(245,138,44,0.3)] hover:shadow-[0_0_60px_rgba(245,138,44,0.5)] hover:-translate-y-1" data-id="element-45">
            Agendar Mi Llamada Gratuita →
          </a>

          <p className="mt-6 text-gray-500 font-medium tracking-wide" data-id="element-46">
            Sin compromiso · Sin contratos · Resultados garantizados
          </p>
        </motion.div>
      </div>
    </section>;
}